import React from 'react';
import { Alert, Link } from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';
import { useFuelType } from './FuelTypeProvider';
import { ALERT_AND_HEADER } from '../constants';
import './fuelTypeAlert.scss';

export const FuelTypeAlert = () => {
  const {
    entryType,
    onAlertClick
  } = useFuelType();

  const alertContent = (
    <>
      { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        variant={entryType === 'ALERT' ? 'body-sm' : 'body-base'}
        height="tight"
        underline="always"
        onClick={onAlertClick}
      >
        {ALERT_AND_HEADER}
      </Link>
    </>
  );

  switch (entryType) {
  case 'ALERT':
    return (
      <div
        data-testid="appliance-fuel-type-link-alert"
        className="removed-alert-bottom-margin sui-max-w-80"
      >
        <Alert
          status="info"
          size="small"
        >
          {alertContent}
        </Alert>
      </div>
    );
  case 'BASIC':
    return (
      <div
        data-testid="appliance-fuel-type-link-basic"
        className="sui-flex sui-items-center sui-gap-2"
      >
        <Info color="info" />
        {alertContent}
      </div>
    );
  default:
    return null;
  }
};
